import React, { useContext, useRef, useState } from 'react'

import { API } from 'API'
import { RequestToasterContext } from 'containers/Providers/RequestToasterProvider'
import { StandardErrorResponse } from 'types/APIResponses'

export const AccountImportDSS = () => {
  const [importDSSStatus, setImportDSSStatus] = useState('')
  const [isImportDSSApply, setIsImportDSSApply] = useState(false)
  const handleToggleIsImportOFRApply = (event: React.ChangeEvent<HTMLInputElement>) =>
    setIsImportDSSApply(event.target.checked)

  const { requestStatusRef } = useContext(RequestToasterContext)
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleImportDSS = () => {
    const file = fileInputRef.current?.files?.item(0) ?? null

    if (!file) {
      alert('No file chosen')
      return
    }
    requestStatusRef.current?.startProgress('Importing file...', 'secondary')
    API.importAccountDSS({
      importDSSApply: isImportDSSApply,
      file,
    })
      .then((result) => {
        requestStatusRef.current?.showAlert('File imported', 'success')
        setImportDSSStatus(result)
      })
      .catch((error: StandardErrorResponse) => {
        requestStatusRef.current?.showAlert(error.response.data.error, 'danger')
      })
  }

  return (
    <div className="mt-4">
      <span className="w-25 d-inline-block">
        Import DSS{' '}
        <a className="m-1" href="/resources/DSS-assingement-sample.xlsx">
          sample file
        </a>
      </span>
      <input className="" ref={fileInputRef} type="file" />
      <input type="checkbox" id="apply" className="mr-1" onChange={handleToggleIsImportOFRApply} />
      <label className="mr-1" htmlFor="apply">
        Apply
      </label>
      <button className="mr-1" onClick={handleImportDSS}>
        Import
      </button>
      <pre className="mt-3">{importDSSStatus}</pre>
    </div>
  )
}
